__turbopack_context__.v({
  "copyButton": "GatewaySelector-module-scss-module__kDTpLa__copyButton",
  "icon": "GatewaySelector-module-scss-module__kDTpLa__icon",
  "name": "GatewaySelector-module-scss-module__kDTpLa__name",
  "wrapper": "GatewaySelector-module-scss-module__kDTpLa__wrapper",
});
